/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react"
import { categoryShape } from "utils/propTypeShapes"
import { FormsyMultilineTextInput } from "shared/inputs"

const CategoryDescription = ({ category }) => {
  const { id } = category

  const inputId = `category-${id}-description-input`

  return (
    <div>
      <label htmlFor={inputId} className="field-name">Description (Optional)</label>
      <FormsyMultilineTextInput
        uuid={inputId}
        className="bordered-base-input text-sm"
        name="description"
        placeholder="Briefly describe this solution"
        rows="3"
        value={category.description}
      />
    </div>
  )
}

CategoryDescription.propTypes = {
  category: categoryShape.isRequired,
}

export default CategoryDescription
